@if (entryItem()) {
  <div
    class="flex items-center justify-between gap-2 p-1.5 rounded-sm hover:bg-bush-green-15 hover:cursor-pointer"
  >
    <!-- Checkbox -->
    <div>
      <input
        kendoCheckBox
        type="checkbox"
        [checked]="entryItem()?.isSelected ?? true"
        (change)="onSelectionChange($event.target.checked)"
      />
    </div>

    <!-- Entry -->
    <div
      class="flex grow min-w-0"
      (click)="openEntryDetails()"
      (keydown.enter)="openEntryDetails()"
    >
      <div class="flex items-center gap-2 w-full">
        <!-- Avatar -->
        <div
          class="avatar avatar-sm"
          [class]="entryItem() | outlookAvatarClasses: userEmails()"
        >
          @if (
            (entryItem()?.type === EntryType.AbEntry ||
              (entryItem()?.type === EntryType.Lead &&
                isUser(entryItem()?.emailAddress ?? ''))) &&
            entryItem()?.abentryType !== EntryType.Company
          ) {
            <span>{{ entryItem() | outlookAvatarLetters }}</span>
          }
          @if (
            entryItem()?.type === EntryType.Lead &&
            !isUser(entryItem()?.emailAddress ?? '')
          ) {
            <span
              class="fa-icons icon icon-solid icon-12 icon-user-magnifying-glass m-auto"
            ></span>
          } @else if (entryItem()?.abentryType === EntryType.Company) {
            <span
              class="fa-icons icon icon-regular icon-16 icon-building m-auto"
            ></span>
          }
        </div>
        <!-- Details  -->
        <div class="flex flex-col min-w-0 flex-1 overflow-hidden">
          <p
            class="text-body truncate w-full"
            [title]="entryItem()?.displayName"
          >
            {{ entryItem()?.displayName }}
          </p>
          <p
            class="caption text-neutral-70 truncate w-full"
            [title]="entryItem()?.emailAddress"
          >
            {{ entryItem()?.emailAddress }}
          </p>
          @if (entryItem()?.type) {
            <p class="caption text-neutral-70 truncate w-full">
              @if (isTeamMember(entryItem()?.emailAddress ?? '')) {
                {{ 'outlook.shared.labels.teamMember' | translate }} /
              }
              @if (entryItem()?.type === EntryType.Lead) {
                {{ 'outlook.entries.lead' | translate }}
              } @else if (entryItem()?.abentryType === EntryType.Individual) {
                {{ 'individual' | translateVertical }}
              } @else {
                {{ 'outlook.entries.' + entryItem()?.abentryType | translate }}
              }
            </p>
          }
        </div>
      </div>
    </div>

    <!-- Actions -->
    <div class="flex-shrink-0">
      <kendo-dropdownbutton
        [title]="'outlook.compose.actions' | translate"
        [data]="entryActionItems()"
        themeColor="tertiary"
        iconClass="fa-icons icon-ellipsis-vertical icon-16 px-1"
        [popupSettings]="{ appendTo: viewContainerRef }"
      ></kendo-dropdownbutton>
    </div>
  </div>
}
